import MultiSelect from "components/common/MultiSelect";
import { GetAllPoyer } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import React, { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleDashboardFilter } from "../config/dashboardSlice"; // Ensure this import path is correct
import { Controller } from "react-hook-form";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
// import { GetAllGeneralDashboard } from "../config/dashboardApi";

const MainDashboardFilter = ({ watch, setValue, control, onFilter }) => {
  const dispatch = useDispatch();
  const { poyerList } = useSelector((state) => state.eligibilityCheckList);
  const { dashboardFilters } = useSelector((state) => state.dashboard);
  const allBranches = JSON.parse(localStorage.getItem("branch_settings")) || [];

  const handlePayer = (selected) => {
    let value = [];
    if (selected && selected.length > 0) {
      value = selected.map((item) => ({
        payer_name: item.label,
        payer_id: item.value,
      }));
    }
    setValue("payer", value);
    dispatch(handleDashboardFilter({ check: "payer", value }));
  };

  const handleBranches = (selected) => {
    let value = [];
    if (selected && selected.length > 0) {
      value = selected.map((item) => ({
        branch_name: item?.label,
        branch_id: item?.value,
        cchi: item?.cchi,
      }));
    }
    setValue("branches", value);
    dispatch(handleDashboardFilter({ check: "branches", value }));
  };

  const handleDate = (newValue) => {
    let value = newValue || [];
    setValue("date", value);
    dispatch(handleDashboardFilter({ check: "date", value }));
  };

  useEffect(() => {
    if (poyerList?.length === 0) dispatch(GetAllPoyer());
  }, [dispatch]);

  useEffect(() => {
    setValue("branches", dashboardFilters?.branches || []);
    setValue("date", dashboardFilters?.date);
    setValue("payer", dashboardFilters?.payer || []);
  }, [dashboardFilters, setValue]);

  return (
    <Form onSubmit={onFilter}>
      <Row alignItems="center" className="mb-3">
        <Col xs={12} sm={6} md={3} xl={2}>
          <label className="form-label">Branches</label>
          <Controller
            name="branches"
            control={control}
            rules={{
              required: false,
            }}
            render={({ field, fieldState: { error } }) => (
              <MultiSelect
                {...field}
                isMulti
                isClearable
                options={allBranches.map((b) => ({
                  value: b.branch_id,
                  label: b.branch_name,
                  cchi: b.branch_cchino,
                }))}
                value={watch("branches")?.map((item) => ({
                  value: item?.branch_id,
                  label: item?.branch_name,
                  cchi: item?.cchi,
                }))}
                onChange={(val) => handleBranches(val)}
                placeholder="Choose branches..."
                className={error ? "is-invalid" : ""}
              />
            )}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <Form.Group controlId="payer">
            <Form.Label>Payer</Form.Label>
            <Controller
              name="payer"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={true}
                  size="sm"
                  options={poyerList?.map((poyer) => ({
                    value: poyer.payer_id,
                    label: poyer.payer_name,
                  }))}
                  placeholder="Choose..."
                  isClearable={true}
                  className={error ? "is-invalid" : ""}
                  value={
                    Array.isArray(field.value)
                      ? field.value.map((item) => ({
                        value: item.payer_id,
                        label: item.payer_name,
                      }))
                      : []
                  }
                  onChange={(selected) => handlePayer(selected)}
                />
              )}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} md={3} xl={2}>
          <BootDatePicker
            name="date"
            label="Date"
            control={control}
            selected={watch("date")}
            showTodayButton={false}
            showPredefinedRanges={true}
            onChange={(newValue) => handleDate(newValue)}
            selectsRange
            popperProps={{ strategy: "fixed" }}
          />
        </Col>
        <Col xs={12} sm={6} md={3} xl={2} className="mt-4">
          <Button type="submit" size="sm">
            Filter
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default MainDashboardFilter;
